module.exports = "/work-site/img/pims.03611b35.png";